<script setup lang="ts">
import { reactive, ref, onMounted } from 'vue'

import { usePageStore } from '../../stores/page'
import { useCdnImages } from '../../composables/use-cdn-images'

const props = defineProps<{
  brand?: string
}>()

const { cdnImageUrl } = useCdnImages()
const { setPrintPreview } = usePageStore()

const buttonLabel = reactive({
  active: 'Bilder ausblenden',
  imagesVisible: 'Bilder ausblenden',
  imagesHidden: 'Bilder einblenden'
})
const logoImageUrl = ref('')

const toggleImagesForPrint = () => {
  const imageContainer = document.querySelectorAll('figure')
  Array.from(imageContainer).forEach((el) => {
    el.classList.toggle('bx-js-hide-container')
  })
  window.dispatchEvent(new Event('resize'))
  buttonLabel.active = (buttonLabel.active === buttonLabel.imagesVisible) ? buttonLabel.imagesHidden : buttonLabel.imagesVisible
}

const printPage = () => {
  window.print()
}

const leavePrintPreview = () => {
  scroll(0, 0)
  document.body.classList.remove('bx-page--print')
  document.getElementsByTagName('header')[0].removeAttribute('style')
  if (buttonLabel.active === buttonLabel.imagesHidden) {
    toggleImagesForPrint()
  }
  setPrintPreview(false)
  window.dispatchEvent(new Event('resize'))
}

onMounted(() => {
  logoImageUrl.value = cdnImageUrl(`/images/${props.brand}/${props.brand}-logo.svg`)
  // We use the resize event in this component to trigger a slider resize
  // that prevents white space in the print preview
  window.dispatchEvent(new Event('resize'))
})
</script>

<template>
  <div class="bx-print-header">
    <div class="bx-print-header__actionbar bx-typo--form">
      <button class="bx-form__button"
              @click="toggleImagesForPrint()">
        {{ buttonLabel.active }}
      </button>
      <button class="bx-form__button"
              @click="printPage()">
        Druck starten
      </button>
      <button class="bx-form__button"
              @click="leavePrintPreview()">
        Abbrechen
      </button>
    </div>

    <img :src="logoImageUrl"
         class="bx-print-header__logo">
  </div>
</template>
